const SkeletonCell = ({ className = "w-16" }: { className?: string }) => (
  <div className={`h-[14px] animate-pulse rounded bg-gray-300 ${className}`} />
);

export const ServiceSkeleton = ({ serviceIndex = 0 }: { serviceIndex?: number }) => (
  <div className="border border-gray-200 rounded-md my-6">
    <div
      className={`${serviceIndex % 2 === 0 ? "bg-blue-50" : "bg-gray-50"} p-3 rounded-md mb-4 flex flex-row justify-between items-center`}
    >
      <SkeletonCell className="w-40 h-[16px]" />
    </div>

    <div className="overflow-x-auto px-2">
      <table
        className="table table-layout-fixed table-column-overflow-hidden table-head-filled mb-3 w-full [&_td]:border-0 [&_th]:border-0"
        style={{ borderCollapse: "separate", borderSpacing: 0 }}
      >
        <thead>
          <tr>
            <th className="w-[7%]"><SkeletonCell className="w-8" /></th>
            <th className="w-[13%]"><SkeletonCell className="w-12" /></th>
            <th className="w-[26%]"><SkeletonCell className="w-20" /></th>
            <th className="w-[10%]"><SkeletonCell className="w-10 mx-auto" /></th>
            <th className="w-[12%]"><SkeletonCell className="w-14 ml-auto" /></th>
            <th className="w-[10%]"><SkeletonCell className="w-12 ml-auto" /></th>
            <th className="w-[13%]"><SkeletonCell className="w-16 mx-auto" /></th>
            <th className="w-[15%]"><SkeletonCell className="w-16 ml-auto" /></th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 10 }).map((_, rowIndex) => (
            <tr key={`service-skeleton-row-${rowIndex}`} className="h-[50px]">
              <td><SkeletonCell className="w-10" /></td>
              <td><SkeletonCell className="w-16" /></td>
              <td><SkeletonCell className="w-28" /></td>
              <td className="text-center"><SkeletonCell className="w-8 mx-auto" /></td>
              <td className="text-right"><SkeletonCell className="w-14 ml-auto" /></td>
              <td className="text-right"><SkeletonCell className="w-10 ml-auto" /></td>
              <td className="text-center"><SkeletonCell className="w-20 h-[25px] mx-auto rounded" /></td>
              <td className="text-right"><SkeletonCell className="w-16 ml-auto" /></td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td className="text-right" colSpan={8}>
              <div className="flex justify-end gap-2 py-2">
                <SkeletonCell className="w-28" />
                <SkeletonCell className="w-20" />
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
);
